<template>
  <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
    <v-icon
      :class="evaluateClasses(classes)"
      :color="evalColorExpression(model.Color)"
      >{{ evaluateExpression(model.Icon) }}</v-icon
    >
  </dr-wrapper>
  <v-icon
    v-else-if="isVisible"
    :class="evaluateClasses(classes)"
    :color="evaluateExpression(model.Color)"
    >{{ evaluateExpression(model.Icon) }}</v-icon
  >
</template>

<script>
import mixin from '../../mixins/base-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
import inputMixin from '../../mixins/input-mixin'
export default {
  mixins: [mixin, inputMixin, widgetsWrapperMixin]
}
</script>

<style>
</style>
